<script setup lang="ts">
definePage({ meta: { permissionKey: "page.whatsapp" } });
const router = useRouter();
onBeforeMount(() => router.replace({ name: "whatsapp-tab", params: { tab: "live-msgs" } }));
</script>
<template><div /></template>
